import {
    REQUEST_ITEM,
    RECEIVE_ITEM,
    UPDATE_ITEM,
    ERROR_ITEM
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import _isObject from 'lodash/isObject'

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_ITEM:
            return {
                ...state,
                isFetching: true,
                key: action.payload,
                message: '',
                errors: {}
            }
        case RECEIVE_ITEM:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                errors: {},
                message: action.message,
            }
        case UPDATE_ITEM:
            const data = state.data
            switch(action.updateType) {
                case 'loginLog':
                    data.logs.login = action.payload
                    break
            }
            return {
                ...state,
                data
            }
        case ERROR_ITEM:
            return {
                ...state,
                isFetching: false,
                errors: action.payload,
                message: _isObject(action.payload) && action.payload.server ? action.payload.server : ''
            }
        default:
            return state
    }
}